"use client";

import { createTheme, MantineColorsTuple } from "@mantine/core";
const TripatraColor: MantineColorsTuple = [
  '#f1f2f8',
  '#e1e2ea',
  '#bfc2d6',
  '#9ba1c3',
  '#7c84b2',
  '#6972a9',
  '#5f69a5',
  '#4f5891',
  '#454e82',
  '#3a4374'
];

export const theme = createTheme({
  colors: {
    Tripatra: TripatraColor,
  },
  cursorType: 'pointer',
});
